import React from "react";
import { useNavigate } from "react-router-dom";
import MainMenuItem from "app/components/MainMenuItem";
import Path from "app/route/Path";

function ProductMenuItem(props) {
  const navigate = useNavigate();

  const onMenuItemClicked = () => {
    navigate(Path.product.home);
  };

  return (
    <MainMenuItem
      itemTitleString="商品発注の管理"
      onClick={onMenuItemClicked}
      size="100%"
    />
  );
}

export default ProductMenuItem;
